/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import moment from 'moment';
import iconSign from 'assets/images/icon-sign.svg';
import { DocumentsState } from 'store/modules/documents_store/types';
import { authenticateDocument } from 'store/modules/documents_store/actions';
import InputMask from 'react-input-mask';
import SquareLoader from '../square_loader';
import { Container } from './styles';

interface ModalAuthenticateDocumentProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  currentDocumentId: string;
}

const ModalAuthenticateDocument = (props: ModalAuthenticateDocumentProps) => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const { documents, request } = useSelector<ApplicationState, DocumentsState>(
    (state) => state.session.documents,
  );

  const { showModal, setShowModal, currentDocumentId } = props;
  const [name, setName] = useState<string>(profile?.name || '');
  const [cpf, setCpf] = useState<string>(profile?.cpf || '');
  const [phone, setPhone] = useState<string>(
    `(${profile?.ddd_cellphone || ''}) ${profile?.cellphone || ''}`,
  );
  const [email, setEmail] = useState<string>(profile?.email || '');
  const [enabledButton, setEnabledButton] = useState<boolean>(false);
  const [showTerm, setShowTerm] = useState<boolean>(false);
  const [termChecked, setTermChecked] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setName(profile?.name || '');
    setCpf(profile?.cpf || '');
    setPhone('');
    setEmail(profile?.email || '');
    setEnabledButton(false);
    setShowTerm(false);
    setTermChecked(false);
  }, [showModal]);

  useEffect(() => {
    setEnabledButton(name !== '' && cpf !== '' && phone !== '' && email !== '');
  }, [name, cpf, phone, email]);

  useEffect(() => {
    if (request.authenticate_document.loaded) {
      setShowModal(false);
    }
  }, [request.authenticate_document]);

  return (
    <Modal show={showModal} size="lg">
      <Container>
        {!showTerm && (
          <div className="row">
            <div className="col-md-12">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Autenticar Documento</h5>
                  <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row mb-3">
                    <div className="col-md-12">
                      Para autenticar o documento, preencha os seguintes <b>campos obrigatórios</b>{' '}
                      para o Termo de Responsabilidade
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-4 position-relative">
                      <label htmlFor="name" className={`m-0 ${name === '' && 'text-danger'}`}>
                        Nome
                      </label>
                      <input
                        type="text"
                        className={`form-control ${name === '' && 'is-invalid'}`}
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <div id="name" className="invalid-feedback position-absolute mt-0">
                        Nome é obrigatório.
                      </div>
                    </div>
                    <div className="col-md-6 mb-4 position-relative">
                      <label htmlFor="cpf" className={`m-0 ${cpf === '' && 'text-danger'}`}>
                        CPF
                      </label>
                      <InputMask
                        type="text"
                        className={`form-control ${cpf === '' && 'is-invalid'}`}
                        id="cpf"
                        placeholder={cpf}
                        mask="999.999.999-99"
                        value={cpf}
                        onChange={(e) => setCpf(e.target.value)}
                      />
                      <div id="cpf" className="invalid-feedback position-absolute mt-0">
                        CPF é obrigatório.
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-4 position-relative">
                      <label htmlFor="phone" className={`m-0 ${phone === '' && 'text-danger'}`}>
                        Telefone
                      </label>
                      <InputMask
                        type="text"
                        className={`form-control ${phone === '' && 'is-invalid'}`}
                        id="telefone"
                        mask="(99) 999999999"
                        maskChar=""
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                      <div id="telefone" className="invalid-feedback position-absolute mt-0">
                        Telefone é obrigatório.
                      </div>
                    </div>
                    <div className="col-md-6 mb-4 position-relative">
                      <label htmlFor="email" className={`m-0 ${email === '' && 'text-danger'}`}>
                        Email
                      </label>
                      <input
                        type="text"
                        disabled
                        className={`form-control ${email === '' && 'is-invalid'}`}
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <div id="email" className="invalid-feedback position-absolute mt-0">
                        Email é obrigatório.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    disabled={!enabledButton}
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setShowTerm(true)}
                  >
                    Gerar termo de solicitação
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showTerm && (
          <div className="modal-content">
            <div className="modal-header align-items-center pl-2">
              <button
                aria-label="Close"
                className="btn btn-link p-0 mr-2"
                data-dismiss="modal"
                type="button"
                onClick={() => setShowTerm(false)}
              >
                <i className="material-icons align-middle">keyboard_arrow_left</i>
              </button>
              <h5 className="modal-title">Autenticar Documento</h5>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body scroll-modal">
              <div className="row">
                <div className="col-12">
                  <h6 className="font-weight-bold text-center mb-3">Termo de Responsabilidade</h6>
                  <p>
                    Eu, {name}, inscrito no CPF: {cpf} solicito a autenticação do(s) documento(s) em
                    anexo à este Termo de Responsabilidade (“Termo”) para os devidos fins de direito
                    ao Consórcio Nacional de Licitação Hqz Ltda e DECLARO desde já que, os
                    documentos ora submetidos à autenticação são:
                  </p>
                  <ul>
                    <li>I - Originais, feitos por mim sob a forma eletrônica;</li>
                    <li>
                      II - Originais, feitos por terceiros, sob a forma eletrônica, que se encontram
                      sob a minha guarda, não tendo os mesmos sido de qualquer forma alterados e/ou
                      rasurados;
                    </li>
                    <li>
                      III - Cópias digitais e fiéis de documentos não eletrônicos, digitalizados por
                      mim e/ou por terceiros sob a minha responsabilidade, que conferem com os
                      originais dos referidos documentos;
                    </li>
                    <li>
                      IV - Extratos digitais de bancos de dados, públicos e/ou privados, cujas
                      informações conferem com o que consta na origem, razão pela qual nos
                      responsabilizamos pela integridade e autenticidade dos mesmos.
                    </li>
                  </ul>
                  <p>
                    <strong>
                      Assumo, nos termos do artigo 8° §1°, do Decreto n° 10.278/2020, a
                      responsabilidade pelo processo de digitalização dos documentos mencionados no
                      item III acima, assegurando a sua autoria, veracidade e integridade.
                    </strong>
                  </p>
                  <p>
                    Declaro, ainda, ter conhecimento de que a autenticação de documento que
                    eventualmente{' '}
                    <strong>
                      <u>contenham rasuras e/ou adulterações</u>
                    </strong>{' '}
                    tem por objetivo,{' '}
                    <strong>
                      <u>único e exclusivo</u>
                    </strong>
                    , preservar e garantir a existência do referido documento com as referidas
                    rasuras e/ou alterações, responsabilizandome, neste caso nos termos da
                    legislação aplicável por estes.
                  </p>
                  <p>Ainda, com a assinatura deste Termo, estou ciente que:</p>
                  <ul>
                    <li>
                      1. O envio deste formulário de solicitação de serviço, junto aos documentos,
                      implicará necessariamente na cobrança pelo serviço, desde que Consórcio
                      Nacional de Licitação Hqz Ltda o execute nos parâmetros acordados.
                    </li>
                    <li>
                      2. O envio dos documentos de forma incorreta e/ou incompleta e/ou inexatos NÃO
                      torna o serviço isento de cobrança.
                    </li>
                    <li>
                      3. O não pagamento por algum serviço solicitado poderá causar o impedimento de
                      novos serviços até que a situação seja regularizada.
                    </li>
                  </ul>
                  <div className="w-50 m-auto text-center">
                    <img alt="icone de assinatura" src={iconSign} />
                    <hr className="mb-1 mt-2 border-dark" />
                    {name} <br />
                    Termo assinado em: {moment(new Date()).format('DD/MM/YYYY')}
                  </div>
                  <div className="font-weight-bold border rounded p-3 mt-3">
                    Este Termo de Responsabilidade foi assinado eletronicamente por meio do meu
                    “ACEITE” nos termos da Lei Federal nº 14.063 Art. 4º inc. I e neste ato,
                    produzirá todos os seus efeitos com relação aos signatários, conforme § 2º Art.
                    10 da Medida Provisória nº2.200-2, de 24/08/2001.
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <input
                type="checkbox"
                className="mr-2"
                checked={termChecked}
                onChange={() => setTermChecked(!termChecked)}
              />
              Declaro que li e concordo com os Termos de Responsabilidade
              <button
                disabled={!termChecked || request.authenticate_document.loading}
                type="button"
                className="btn btn-primary ml-auto"
                onClick={() => {
                  dispatch(
                    authenticateDocument(
                      documents.filter(
                        (document) => document.id.toString() === currentDocumentId,
                      )[0],
                      name,
                      cpf,
                      email,
                      phone,
                    ),
                  );
                }}
              >
                {request.authenticate_document.loading ? (
                  <SquareLoader customClass="authenticate-document-button" />
                ) : (
                  'Autenticar documento'
                )}
              </button>
            </div>
          </div>
        )}
      </Container>
    </Modal>
  );
};

export default ModalAuthenticateDocument;
